<h2>Reset Password</h2>
<div class="col-md-12">
  <div class="row col-md-6 ">
    <div class="col-md-4">
      <span>
        Enter New Password
      </span>
    </div>
    <div class="col-md-8">
      <input type="password" id="userPasswordOne" [(ngModel)]="PasswordOne" maxlength="50" required />
    </div>
  </div>
  <div class="row col-md-6">
    <div class="col-md-4">
      <span>Re-Enter Password</span>
    </div>
    <div class="col-md-8">
      <input type="password" id="userPasswordTwo" [(ngModel)]="PasswordTwo" maxlength="50" required />
      <br />
      <span class="validationMessage" [hidden]="PasswordOne == PasswordTwo || (PasswordOne != PasswordTwo && PasswordTwo.length == 0)">Passwords must match</span>
    </div>
  </div>

  <div class="row col-md-6 text-center">
    <div class="padding-5">
      <button [disabled]="PasswordOne != PasswordTwo && PasswordTwo.length == 0" (click)="CreateNewPassword()">Reset</button>
    </div>
    <div class="padding-5">
      <button (click)="CancelResetPassword()">Cancel</button>
    </div>
  </div>
</div>
<div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:90%;position:absolute;z-index:10000;display:block;top: 80px;;left:0; background-color:#AAAAAA;opacity:0.4;">
  <div style="position:fixed;top:45%;left:45%;">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
</div>
